import Stage from "./Stage";

const Stages = (props) => {

    const stagesDetials = [
        {
            stageName: "Quiz Battle",
            stageImgLink: "https://firebasestorage.googleapis.com/v0/b/djsnsdc-website.appspot.com/o/eventsImages%2FtechnoGrad%2FquizImg.jpg?alt=media&token=215a80a8-21a7-4729-9901-1901ca4c397c",
            stageDesc: "Challenge your tech knowledge with a thrilling quiz covering a spectrum of exciting topics."
        },
        {
            stageName: "Bug Bounty",
            stageImgLink: "https://firebasestorage.googleapis.com/v0/b/djsnsdc-website.appspot.com/o/eventsImages%2FtechnoGrad%2FbugBounty.jpg?alt=media&token=acac584b-f08e-43e9-a6bd-3f8872a64b30",
            stageDesc: "Teams will put their coding prowess to the test by debugging provided codes and finding solutions."
        },
        {
            stageName: "Minute To Win-It",
            stageImgLink: "https://firebasestorage.googleapis.com/v0/b/djsnsdc-website.appspot.com/o/eventsImages%2FtechnoGrad%2FminuteToWinIt_.jpg?alt=media&token=f63e15b8-88b0-4827-a7bc-3d46cc9b3cd0",
            stageDesc: "Participate in a coding competition where quick thinking and coding skills are your keys to victory."
        },
        {
            stageName: "The Grand Finale",
            stageImgLink: "https://firebasestorage.googleapis.com/v0/b/djsnsdc-website.appspot.com/o/eventsImages%2FtechnoGrad%2FgrandFinale.jpg?alt=media&token=801df3c6-73d2-4fd5-a2b1-4d121afbae68",
            stageDesc: "A Secret Round followed by a final convocation ceremony to celebrate your achievements."
        },
    ]

    return (
        <div className="tg23-stage_container">
            <p className="tg23-section-heading" data-value="EVENTS" onMouseOver={props.mouseHover}>EVENTS</p>
            {
                stagesDetials.map((stage, idx)=>
                    <Stage key={idx} stageName={stage.stageName} stageImgLink={stage.stageImgLink} stageDesc={stage.stageDesc} />
                )
            }
        </div>

    );
}

export default Stages